import React, { useEffect, useState } from "react";
import Layout from "../../components/layouts/Layout";
import BreadcrumbBlock from "../../components/BreadcrumbBlock/BreadcrumbBlock";
import { Link, useNavigate } from "react-router-dom";
import {
  Flex,
  Image,
  PaginationProps,
  Table,
  TableColumnsType,
  Tabs,
  Input,
  Button,
  notification,
  DatePicker,
} from "antd";
import {
  Home2,
  SearchZoomIn1,
  DocumentDownload,
  Calendar,
} from "iconsax-react";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import type { TabsProps } from "antd";
import "./style.scss";
import { mixPostV1 } from "../../services/mixin";
import * as XLSX from "xlsx";

const numberFormat = (number: any) => {
  let result;
  if (typeof number === "number") {
    result = new Intl.NumberFormat().format(number);
  } else {
    result = number;
  }
  return result;
};

interface DataType {
  key: React.Key;
  time: string;
  cashOut: number;
  actualCashOut: number;
  machine: string;
  photo: string;
}

const customPrevNext: PaginationProps["itemRender"] = (
  _,
  type,
  originalElement,
) => {
  if (type === "prev") {
    return (
      <Flex align="center" gap={8}>
        <ArrowLeftOutlined />
        <span>Previous</span>
      </Flex>
    );
  }
  if (type === "next") {
    return (
      <Flex align="center" gap={8}>
        <span>Next</span>
        <ArrowRightOutlined />
      </Flex>
    );
  }
  return originalElement;
};

const MemberCashOutNormal: React.FC = () => {
  const navigate = useNavigate();
  const can_view_payout_report =
    localStorage.getItem("can_view_payout_report") ?? "0";
  const [loading, setLoading] = useState(false);
  const [currentTab, setCurrentTab] = useState<string>("cash-out-with-proof");
  const [exportLoading, setExportLoading] = useState(false);
  const [items, setItems] = useState({
    list: [],
    total: 0,
  });

  const [params, setParams] = useState<{
    limit: number;
    page_number: number;
    searchKey: string;
    date_search: string;
    x: number;
    tab: string;
  }>({
    limit: 10,
    page_number: 1,
    searchKey: "",
    date_search: "",
    x: 0,
    tab: "cash-out-with-proof",
  });

  const columns: TableColumnsType<DataType> = [
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
    },
    {
      title: "Staff",
      dataIndex: "staff_name",
      key: "staff_name",
    },
    {
      title:
        currentTab !== "cash-out-without-proof"
          ? "Cash-out"
          : "Amount on machine",
      dataIndex: "cashOut",
      key: "cashOut",
      render: (value, record, index) => <span>{numberFormat(value)}</span>,
    },
    {
      title: "Actual Cash-out",
      dataIndex: "actualCashOut",
      key: "actualCashOut",
      hidden: currentTab !== "cash-out-without-proof",
      render: (value, record, index) => <span>{numberFormat(value)}</span>,
    },
    {
      title: "Machine",
      dataIndex: "machine",
      key: "machine",
    },
    {
      title: "Photo",
      dataIndex: "photo",
      key: "photo",
      // hidden: currentTab !== "pay-bonus",
      render: (value, record, index) => (
        <div style={{ marginBlock: -8 }}>
          {value && (
            <Image
              height={48}
              width={48}
              src={`${value}`}
              fallback="data:image/png;base64,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"
            />
          )}
        </div>
      ),
    },
  ];

  useEffect(() => {
    getCashOutWithProof();
  }, []);

  useEffect(() => {
    if (params.x !== 0) {
      if (params.tab === "cash-out-with-proof") {
        getCashOutWithProof();
      }

      if (params.tab === "cash-out-without-proof") {
        getCashOutWithoutProof();
      }

      if (params.tab === "pay-bonus") {
        getHistoryPayBonusCustomer();
      }
    }
  }, [params.x]);

  // TABS
  const tabs: TabsProps["items"] = [
    {
      key: "cash-out-with-proof",
      label: "Payout",
    },
    {
      key: "pay-bonus",
      label: "Pay Bonus",
    },
    {
      key: "cash-out-without-proof",
      label: "Manual payout",
    },
  ];
  const onTabChange = (key: string) => {
    setCurrentTab(key);

    setParams({ ...params, page_number: 1, x: params.x + 1, tab: key });

    // if (key === 'cash-out-with-proof') {
    //   getCashOutWithProof()
    // }

    // if (key === 'cash-out-without-proof') {
    //   getCashOutWithoutProof()
    // }

    // if (key === 'pay-bonus') {
    //   getHistoryPayBonusCustomer()
    // }
  };
  // END TABS

  // GET CASH OUT WITH PROOF
  const getCashOutWithProof = async () => {
    setLoading(true);

    try {
      const param = {
        page_number: params.page_number,
        limit: params.limit,
      } as any;
      if (params.searchKey) {
        param.searchKey = params.searchKey;
      }
      if (params.date_search) {
        param.date_search = params.date_search;
      }
      const res = await mixPostV1(
        "/api/webAdmin/gHistoryCashoutWithProof.php",
        param,
      );

      if (res.status === 1) {
        setLoading(false);
        const result: any = [];
        res.data.map((item: any) =>
          result.push({
            ...item,
            key: item.id,
            time: item.timecashout,
            cashOut: item.match_amount,
            actualCashOut: 0,
            machine: item.machine_number,
            photo: item.photo_url,
          }),
        );
        const total = res.total;
        setItems({
          list: result,
          total,
        });
      }
    } catch (error) {}
  };
  // END GET CASH OUT WITH PROOF

  // GET CASH OUT WITHOUT PROOF
  const getCashOutWithoutProof = async () => {
    setLoading(true);

    try {
      const param = {
        page_number: params.page_number,
        limit: params.limit,
      } as any;
      if (params.searchKey) {
        param.searchKey = params.searchKey;
      }
      if (params.date_search) {
        param.date_search = params.date_search;
      }
      const res = await mixPostV1(
        "/api/webAdmin/gHistoryCashoutWithOutProof.php",
        param,
      );

      if (res.status === 1) {
        setLoading(false);
        const result: any = [];
        res.data.map((item: any) =>
          result.push({
            ...item,
            key: item.id,
            time: item.timecashout,
            cashOut: item.amount_machine,
            actualCashOut: item.match_amount,
            machine: item.machine_number,
            photo: item.photo_url,
          }),
        );
        const total = res.total;
        setItems({
          list: result,
          total,
        });
      }
    } catch (error) {}
  };
  // END GET CASH OUT WITHOUT PROOF

  // GET HISTORY PAY BONUS CUSTOMER
  const getHistoryPayBonusCustomer = async () => {
    setLoading(true);

    try {
      const param = {
        page_number: params.page_number,
        limit: params.limit,
      } as any;
      if (params.searchKey) {
        param.searchKey = params.searchKey;
      }
      if (params.date_search) {
        param.date_search = params.date_search;
      }
      const res = await mixPostV1(
        "/api/webAdmin/gHistoryPayBonusCustomer.php",
        param,
      );

      if (res.status === 1) {
        setLoading(false);
        const result: any = [];
        res.data.map((item: any) =>
          result.push({
            ...item,
            key: item.pay_bonus_id,
            time: item.create_at,
            cashOut: item.cash_out_amount,
            actualCashOut: 0,
            machine: item.machine_number,
            photo: item.photo_url,
          }),
        );
        const total = res.total;
        setItems({
          list: result,
          total,
        });
      }
    } catch (error) {}
  };
  // END GET HISTORY PAY BONUS CUSTOMER

  // TABLE
  const onPageChange = (page: number) => {
    setParams({
      ...params,
      page_number: page,
      x: params.x + 1,
    });
  };

  const onTableChange = (data: any) => {
    setParams({
      ...params,
      page_number: data.current,
      limit: data.pageSize,
      x: params.x + 1,
    });
  };
  // TABLE

  const getItemsByExcel = async () => {
    setExportLoading(true);
    const customParams = {
      ...params,
      page_number: 1,
      limit: 10000,
    };

    let api = "/api/webAdmin/gHistoryCashoutWithProof.php";

    if (currentTab === "cash-out-without-proof") {
      api = "/api/webAdmin/gHistoryCashoutWithOutProof.php";
    }

    if (currentTab === "pay-bonus") {
      api = "/api/webAdmin/gHistoryPayBonusCustomer.php";
    }

    try {
      const res = await mixPostV1(api, customParams);

      if (res.status) {
        if (res.data.length > 0) {
          formattedDataExcel(res.data);
          setExportLoading(false);
        } else {
          setExportLoading(false);
          openNotification("error", "There is no data to export!");
        }
      } else {
        setExportLoading(false);
        openNotification("error", "Oops, something went wrong!");
      }
    } catch (error) {
      setExportLoading(false);
      openNotification("error", "Oops, something went wrong!");
    }
  };
  const formattedDataExcel = (data: any) => {
    const formattedData = data.map((item: any) => {
      if (currentTab === "cash-out-with-proof") {
        return {
          Time: item.timecashout,
          Staff: item.staff_name,
          "Cash-Out": item.match_amount,
          Machine: item.machine_number,
        };
      }
      if (currentTab === "cash-out-without-proof") {
        return {
          Time: item.timecashout,
          Staff: item.staff_name,
          "Amount on machine": item.amount_machine,
          "Actual Cash-out": item.match_amount,
          Machine: item.machine_number,
        };
      }
      if (currentTab === "pay-bonus") {
        return {
          Time: item.timecashout,
          Staff: item.staff_name,
          "Cash-Out": item.match_amount,
          Machine: item.machine_number,
          Photo: item.photo_url,
        };
      }
      return true;
    });
    exportExcel(formattedData, "Member check in list");
  };
  const exportExcel = (
    convertData: any,
    nameExcel = "Member list",
  ): boolean => {
    try {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(convertData);
      const workbook: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Danh sách");

      const excelBuffer: ArrayBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "buffer",
      });

      const saveAsExcel = (buffer: ArrayBuffer, fileName: string): void => {
        const data: Blob = new Blob([buffer], {
          type: "application/octet-stream",
        });
        const link: HTMLAnchorElement = document.createElement("a");
        link.href = window.URL.createObjectURL(data);
        link.download = fileName;
        link.click();
      };

      saveAsExcel(excelBuffer, `${nameExcel}.xlsx`);
      return true; // Export successful
    } catch (error) {
      console.error("Error exporting Excel:", error);
      return false; // Export failed
    }
  };
  // NOTIFICATION
  const [api, contextHolder] = notification.useNotification();
  const openNotification = (
    type: "success" | "error" = "success",
    message = "Level updated!",
  ) => {
    api[type]({
      message,
      placement: "bottomRight",
      className: "single-message",
    });
  };
  useEffect(() => {
    if (Number(can_view_payout_report) === 0) {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {contextHolder}
      <Layout contentClassName="staff-manage-content">
        <BreadcrumbBlock
          items={[
            {
              title: (
                <Flex align="center" gap={16}>
                  <Home2 variant="Bulk" />
                  <Link to="/">CMD Tech</Link>
                </Flex>
              ),
            },
            { title: "Report" },
            { title: "Payout" },
          ]}
          title="Payout"
          description=""
        />

        <div className="table-filter-block v01">
          <div className="col left-box">
            <Input
              placeholder="Search by staff name"
              prefix={<SearchZoomIn1 size={20} variant="Bulk" />}
              className="rs-input w-349 grid-area-search"
              allowClear
              onChange={(e: any) => {
                setParams({
                  ...params,
                  page_number: 1,
                  searchKey: e.target.value,
                  x: params.x + 1,
                });
              }}
            />
            <DatePicker
              placeholder="Select date"
              className="rs-date-picker"
              popupClassName="rs-date-picker-dropdown"
              suffixIcon={<Calendar size={18} variant="Bulk" />}
              onChange={(_, dateStr: any) => {
                setParams({
                  ...params,
                  page_number: 1,
                  date_search: dateStr,
                  x: params.x + 1,
                });
              }}
            />
          </div>
          <Button
            icon={<DocumentDownload size={20} variant="Bulk" />}
            className="rs-button grid-area-export"
            loading={exportLoading}
            onClick={getItemsByExcel}
          >
            Export
          </Button>

          {/* <Button
          icon={<Send2 size={20} variant="Bulk" />}
          className="rs-button grid-area-sendsms"
          onClick={() => setShowAddMemberModal(true)}
        >Send SMS</Button> */}
        </div>

        <Tabs
          defaultActiveKey={currentTab}
          items={tabs}
          className="rs-tabs rs-tabs--no-tab-content"
          onChange={onTabChange}
        />

        <Table
          columns={columns}
          dataSource={items.list}
          className="rs-table text-nowrap t-table-member"
          scroll={{
            x: true,
          }}
          loading={loading}
          showSorterTooltip={false}
          tableLayout="fixed"
          pagination={{
            total: items.total,
            pageSize: params.limit,
            position: ["bottomCenter"],
            showSizeChanger: true,
            showTitle: false,
            current: params.page_number,
            itemRender: customPrevNext,
            onChange: (e) => onPageChange(e),
          }}
          onChange={onTableChange}
        />
      </Layout>
    </>
  );
};

export default MemberCashOutNormal;
